import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { MixService } from './mix-service.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(private mix: MixService) {}

  ngOnInit(){
    
  }

  loadMix(id) {
    this.mix.changeMix(id)
  }

}



// WEBPACK FOOTER //
// /Users/martyndavies/code/algolia/essentialvault-angular/src/app/app.component.ts